import { DdFlagType } from "fe-common/graphql";
import * as React from "react";
import { styled } from "@mui/material";
import { AgentTooltip } from "fe-common/ui/AgentTooltip";
import { DiseaseFlag } from "fe-common/hooks/sortFeaturesWithCrs";

//region [[ Styles ]]

const FlagIcon = styled("span")({
  marginLeft: "3px",
  marginTop: "6px",
  fontSize: "15px",
});

const FLAGS = {
  [DdFlagType.Urgent]: "Urgent",
  [DdFlagType.GoodMatch]: "Good Match",
  [DdFlagType.Rare]: "Rare",
};

function flagText(flags: DiseaseFlag[]) {
  return (flags || []).map((f) => FLAGS[f]).filter((f) => f);
}

//endregion [[ Functions ]] //

export const AgentDiseaseFlags = ({
  flags,
  loading,
}: {
  flags?: DiseaseFlag[];
  loading?: boolean;
}) => {
  const flagsText = flagText(flags);

  return (
    <div style={{ opacity: !loading ? 1 : 0 }}>
      {flagsText.map((f) => {
        switch (f) {
          case "Added":
            return (
              <AgentTooltip key={"Added"} title={f}>
                <FlagIcon>
                  <i className="far fa-trash-alt"></i>
                </FlagIcon>
              </AgentTooltip>
            );
          case "Removed":
            return (
              <AgentTooltip key={"Removed"} title={f}>
                <FlagIcon>
                  <i className="fas fa-plus-hexagon"></i>
                </FlagIcon>
              </AgentTooltip>
            );
          case "Rare":
            return (
              <AgentTooltip key={"Rare"} title={f}>
                <FlagIcon>
                  <i className="fal fa-gem" />
                </FlagIcon>
              </AgentTooltip>
            );
          case "Urgent":
            return (
              <AgentTooltip key={"Urgent"} title={f}>
                <FlagIcon style={{ color: "red" }}>
                  <i className="fad fa-flag" />
                </FlagIcon>
              </AgentTooltip>
            );
          default:
            return null;
        }
      })}
    </div>
  );
};
